import validation from "@/mixins/validation";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { mapActions, mapGetters, mapMutations } from "vuex";
import CustomReviewsSelect from "@/components/popups/reviews-form/components/custom-reviews-select/index.vue";
import StarRating from "vue-star-rating";
import debounce from "lodash/debounce";

export default {
  name: "ReviewsForm",
  data() {
    return {
      payload: {
        name: "",
        email: "",
        message: "",
        rating: null,
      },
      selectedBrand: null,
      selectedProduct: null,
      validationErrors: {},
      loading: false,
    };
  },
  components: {
    CustomReviewsSelect,
    StarRating
  },
  mixins: [validation],
  validations: {
    payload: {
      name: { required, maxLength: maxLength(191) },
      email: { email, maxLength: maxLength(191) },
      message: { required },
      rating: { required },
    },
    selectedBrand: { required },
    selectedProduct: { required },
  },
  created() {
    if (this.isAuthenticated) {
      this.payload.name = this.user.name;
      this.payload.email = this.user.email;
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: `auth/isAuthenticated`,
      user: "profile/user",
      filters: "feedbacks/filters",
      products: "feedbacks/products"
    }),
    nameErrors() {
      return this.computeErrors("payload", "name", {
        required: "validationRequired",
        maxLength: { message: "validationMax", count: 191 },
      });
    },
    emailErrors() {
      return this.computeErrors("payload", "email", {
        email: "validationEmail",
        maxLength: { message: "validationMax", count: 191 },
      });
    },
    messageErrors() {
      return this.computeErrors("payload", "message", {
        required: "validationRequired",
      });
    },
    ratingErrors() {
      return this.computeErrors("payload", "rating", {
        required: "validationRequired",
      });
    },
    brandErrors() {
      return this.fieldErrors("selectedBrand", {
        required: "validationRequired",
      });
    },
    productErrors() {
      return this.fieldErrors("selectedProduct", {
        required: "validationRequired",
      });
    },
    getBrands() {
      return this.filters.find(filter => filter.key === 'brands')?.child?.data || []
    },
    getProducts() {
      return this.products?.data || []
    }
  },
  methods: {
    ...mapActions({
      sendSpecialCosmoBaseForm: "cosmobase/SEND_SPECIAL_COSMOBASE_FORM",
      fetchProducts: "feedbacks/FETCH_PRODUCTS",
      leaveFeedbacks: "feedbacks/LEAVE_FEEDBACK"
    }),
    ...mapMutations({
      changeReviewModalStatus: "popups/CHANGE_LEAVE_REVIEW_MODAL"
    }),
    setRating(value) {
      this.payload.rating = value;
    },
    isStarFilled(value) {
      return this.payload.rating >= value;
    },
    handleSelectBrand(brand) {
      this.selectedBrand = brand
      this.fetchProducts({brands: brand.slug})
    },
    handleSelectProduct(product) {
      this.selectedProduct = product
      console.log(product);
    },
    handleSearchProduct : debounce(function (text) {
      this.fetchProducts({brands: this.selectedBrand.slug, search: text})
    }, 500),
    async sendForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log(this.$v.$invalid);
        return;
      }
      this.loading = true;
      try {
        let localPayload = {
          ...this.payload,
          product_id: this.selectedProduct.id,
          brand_id: this.selectedBrand.id,
        }

        await this.leaveFeedbacks(localPayload);
        this.changeReviewModalStatus(false);
        this.$toasted.success(this.$t('success'));
        this.selectedBrand = null;
        this.selectedProduct = null;
        this.payload = {
          name: "",
          email: "",
          message: "",
          rating: 0
        };
      } catch (error) {
        this.validationErrors = error.data.errors;
        this.$toasted.error(this.$t('error'));
      } finally {
        this.loading = false;
      }
    },
  },
};
